export default [
  'comment_reply',
  'comment_rated',
  'comment_publish',
  'email_confirm',
  'kolokolchick_update_meta',
];
